export default __webpack_public_path__ + "static/media/pdf.2f46bc09.svg";